<template>
  <div class="pullsheet-view">
      <section class="page-header">
        <h1>Password Reset</h1>
      </section>

    <div class="loading" v-if="loading">
<!--     <div class="loading"> -->
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div v-if="tokenCheckResponse" class="content">
      <h1>Set your new password</h1>
      <div class="password-reset-form">
        <form v-on:submit.prevent="changePassword">
          <label for="password">
            Email address
          </label>
          <input type="text" :value="tokenCheckResponse.email" disabled>
          <label for="password">
            Enter a new password
          </label>
          <input type="password" v-model="password" name="password" placeholder="Password">
          <label for="repeatpassword">
            Enter it again
          </label>
          <input type="password" v-model="passwordrepeat" name="repeatpassword" placeholder="Repeat Password">
          <div class="formerror" v-if="formError">{{formError}}</div>
          <button type="submit"  v-bind:disabled="formLoading">Set new password</button>
        </form>
      </div>
     </div><!-- /.content -->

    <div v-if="complete" class="content">
      <h1>Your password has been reset</h1>
      <p>You can now log in with your new password.</p>
    </div><!-- /.content -->

  </div><!-- /.pl-detail -->
</template>

<script>
export default {
  name: 'PasswordReset',
  data () {
    return {
      loading: false,
      error: null,
      formError: false,
      formLoading: false,
      tokenCheckResponse: null,
      password: '',
      passwordrepeat: '',
      complete: false
    }
  },
  created () {
    this.fetchData()
    document.title = 'Reset Password - The Renees'
    document.head.querySelector('meta[name=description]').content = ''
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.error = this.PullSheet = null
      this.loading = true
      this.$http.get(this.$root.apiurl + 'user/checkresettoken/', {params: { token: this.$route.params.token }}).then(response => {
        if (!response.body.success) {
          this.error = response.body.message
        } else {
          this.tokenCheckResponse = response.body
        }
        this.loading = false
      }, response => {
        this.error = response.statusText
      })
    },
    changePassword () {
      this.formLoading = true
      this.formError = false
      if (this.password === '') {
        this.formError = 'Please enter a password.'
        this.formLoading = false
        return
      }
      if (this.password !== this.passwordrepeat) {
        this.formError = 'Passwords must match.'
        this.formLoading = false
        return
      }
      this.$http.get(this.$root.apiurl + 'user/resetpasswordcomplete',
        {
          params: {
            token: this.$route.params.token,
            newpassword: this.password
          }
        }).then(response => {
          if (response.body.success) {
            this.formLoading = false
            this.formError = false
            this.tokenCheckResponse = false
            this.complete = true
          } else {
            this.formLoading = false
            this.formError = response.body.message
          }
        }, response => {
          this.formLoading = false
          this.formError = response.statusText
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";

.loading {
  height: 100vh;
  padding-top: 49vh;
  box-sizing: border-box;
  text-align: center;
  background: #FFF;
}

.error {
  padding: 10em 0;
  text-align: center;
  font-size: 1.25em;
  font-weight: 500;
}

.content {
  max-width: 36em;
  margin: 0px auto;
  padding: 2em 0 6em;
  h1 {
    font-weight: 100;
  }
}


form {
  padding: 1.5em;
  border: 1px solid #d1d1d1;
  border-radius: 3px;
  label {
    display: block;
    font-family: $noto;
    color: $notblack;
    margin: .25em 0;
  }
  input {
    display: block;
    width: 100%;
    box-sizing: border-box;
    font-size: 1.25em;
    font-family: $montserrat;
    border: 0px none;
    border-bottom: 1px solid $darkgrey;
    padding: .5em .25em;
    margin: .25em 0 1em;
    color: $notblack;
    &:disabled {
      color: #AAA;
      border-bottom: 0px none;
    }
  }
  button {
    background: $blue;
    outline: none;
    border: 0px none;
    border-radius: 3px;
    font-family: $montserrat;
    color: #FFF;
    font-weight: 300;
    font-size: 1.25em;
    padding: .25em 1em;
    line-height: 1.4;
    cursor: pointer;
    &:disabled {
      background: #7d7d7d;
    }
  }
}

div.formerror {
  color: #CF0000;
  margin: .5em 0;
}



</style>



// WEBPACK FOOTER //
// PasswordReset.vue?7dbdc9ea